import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconWarehouse: AppIcon = {
  svgData: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M9.333 20h13.334M9.333 24h13.334M9.333 28h13.334M22.667 28V16H9.333v12M13.333 12h5.334" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path clip-rule="evenodd" d="M28 10.667 16 4 4 10.667V28h24V10.667Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'warehouse',
};
